export default __webpack_public_path__ + "823f2a1a332ddc2dccedf8f02c3f98f4.svg";